export type GoogleFontCategory = 'sans-serif' | 'serif' | 'display';

export interface GoogleFontEntry {
  name: string;
  category: GoogleFontCategory;
}

export interface SystemFontEntry {
  name: string;
  value: string;
}

export const GOOGLE_FONTS: GoogleFontEntry[] = [
  // Sans-Serif
  { name: 'Inter', category: 'sans-serif' },
  { name: 'Roboto', category: 'sans-serif' },
  { name: 'Open Sans', category: 'sans-serif' },
  { name: 'Lato', category: 'sans-serif' },
  { name: 'Montserrat', category: 'sans-serif' },
  { name: 'Nunito', category: 'sans-serif' },
  { name: 'Poppins', category: 'sans-serif' },
  { name: 'Raleway', category: 'sans-serif' },
  { name: 'Work Sans', category: 'sans-serif' },
  { name: 'Source Sans 3', category: 'sans-serif' },
  { name: 'DM Sans', category: 'sans-serif' },
  // Serif
  { name: 'Playfair Display', category: 'serif' },
  { name: 'Merriweather', category: 'serif' },
  { name: 'Lora', category: 'serif' },
  { name: 'EB Garamond', category: 'serif' },
  { name: 'Cormorant Garamond', category: 'serif' },
  { name: 'Libre Baskerville', category: 'serif' },
  { name: 'Source Serif 4', category: 'serif' },
  // Display
  { name: 'Oswald', category: 'display' },
  { name: 'Bebas Neue', category: 'display' },
  { name: 'Abril Fatface', category: 'display' },
  { name: 'Cinzel', category: 'display' },
  { name: 'Josefin Sans', category: 'display' },
];

export const SYSTEM_FONTS: SystemFontEntry[] = [
  {
    name: 'System Default',
    value: "'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif",
  },
  {
    name: 'Georgia',
    value: "Georgia, 'Times New Roman', Times, serif",
  },
  {
    name: 'Verdana',
    value: 'Verdana, Geneva, Tahoma, sans-serif',
  },
];

export const CUSTOM_FONT_VALUE = '__custom__';

export function classifyFont(
  fontValue: string
):
  | { type: 'google'; entry: GoogleFontEntry }
  | { type: 'system'; entry: SystemFontEntry }
  | { type: 'custom' } {
  const googleMatch = GOOGLE_FONTS.find((f) => f.name === fontValue);
  if (googleMatch) return { type: 'google', entry: googleMatch };

  const systemMatch = SYSTEM_FONTS.find((f) => f.value === fontValue);
  if (systemMatch) return { type: 'system', entry: systemMatch };

  return { type: 'custom' };
}

export function googleFontUrl(fontName: string): string {
  const family = fontName.replace(/ /g, '+');
  return `https://fonts.googleapis.com/css2?family=${family}:wght@300;400;500;600;700&display=swap`;
}

export function googleFontCssValue(entry: GoogleFontEntry): string {
  return `'${entry.name}', ${entry.category}`;
}
